import { useEffect } from "react";
import { Row, Col } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import Header from "../Landing/Header";
import Footer from "../Landing/Footer";
import "../ContactSales/contact.scss";
import { StoreImages } from "../../Storeimgaes/StoreImages";

const { SignInMobile } = StoreImages;

export default function Support() {
    useEffect(() => {
        // Load HubSpot script
        const script = document.createElement("script");
        script.src = "//js.hsforms.net/forms/embed/v2.js";
        script.type = "text/javascript";
        script.charset = "utf-8";
        script.async = true;

        script.onload = () => {
            if (window.hbspt) {
                window.hbspt.forms.create({
                    portalId: "47912322",
                    formId: "166bd4ff-d095-4980-86d5-336062b03684",
                    region: "na1",
                    target: "#hubspot-support-form",
                    css:""
                });
            }
        };

        document.body.appendChild(script);

        return () => {
            if (document.body.contains(script)) {
                document.body.removeChild(script);
            }
        };
    }, []);

    return (
        <div className="contact-sales">
            <div
                className="contact-sales-inner"
                style={{ background: "#1e3b5a", padding: "2rem", color: "#fff" }}
            >
                <Header />
                <div className="container" style={{ paddingTop: "150px" }}>
                    <Row gutter={32} align="middle">
                        <Col xs={24} md={12} style={{ padding: "1rem" }}>
                            <div className="support-header">
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                }}>
                                    <QuestionCircleOutlined
                                        style={{
                                            fontSize: '1.2rem',
                                            color: '#64b5f6'
                                        }}
                                    />
                                    <h1
                                        style={{
                                            color: "#fff",
                                            fontSize: "1.2rem",
                                            fontWeight: "600",
                                            margin: 0
                                        }}
                                    >
                                        Need Help?
                                    </h1>
                                </div>
                            </div>

                            <div id="hubspot-support-form" className="contact-form hubspot-form-container"></div>
                        </Col>

                        {/* Right Mobile View Section */}
                        <Col className="contact-sale-right" xs={0} md={12} style={{ textAlign: "right" }}>
                            <img
                                src={SignInMobile}
                                alt="mobile support"
                                style={{ maxWidth: "63%", marginRight: "auto" }}
                            />
                        </Col>
                    </Row>
                </div>
            </div>

            <Footer />

            <style jsx>{`
        .support-header {
          background: rgba(255, 255, 255, 0.05);
          border-radius: 16px;
          padding: 1rem;
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.1);
        }
        
        .contact-form {
          min-height: 400px;
        }

        /* HubSpot Form Overrides - Multiple approaches */
        .hubspot-form-container .hsfc-Step .hsfc-Step__Content,
        #hubspot-support-form .hsfc-Step .hsfc-Step__Content,
        .hsfc-Step .hsfc-Step__Content {
          padding: 0 !important;
          --hsf-background__padding: 0 !important;
          --hsf-default-background__padding: 0 !important;
        }

        /* Additional HubSpot form styling overrides */
        .hubspot-form-container .hs-form {
          padding: 0 !important;
        }

        .hubspot-form-container .hs-form-field {
          margin-bottom: 1rem !important;
        }

        .hubspot-form-container .hs-fieldtype-text input,
        .hubspot-form-container .hs-fieldtype-textarea textarea,
        .hubspot-form-container .hs-fieldtype-select select {
          background: rgba(255, 255, 255, 0.1) !important;
          border: 1px solid rgba(255, 255, 255, 0.2) !important;
          color: #fff !important;
          border-radius: 8px !important;
          padding: 0.75rem !important;
        }

        .hubspot-form-container .hs-fieldtype-text input::placeholder,
        .hubspot-form-container .hs-fieldtype-textarea textarea::placeholder {
          color: rgba(255, 255, 255, 0.6) !important;
        }

        .hubspot-form-container .hs-form label {
          color: #fff !important;
          font-weight: 500 !important;
        }

        .hubspot-form-container .hs-button {
          background: #64b5f6 !important;
          border: none !important;
          padding: 0.75rem 2rem !important;
          border-radius: 8px !important;
          color: #fff !important;
          font-weight: 600 !important;
          cursor: pointer !important;
          transition: all 0.3s ease !important;
        }

        .hubspot-form-container .hs-button:hover {
          background: #42a5f5 !important;
          transform: translateY(-2px) !important;
        }
        
        @media (max-width: 768px) {
          .support-header h1 {
            font-size: 1.2rem !important;
          }
        }
      `}</style>
        </div>
    );
}